// extracted by mini-css-extract-plugin
export default {"noMarginLeft":"noMarginLeft---vJKAo","resetButton":"resetButton---_g0eH","totalCountWrapper":"totalCountWrapper---fLzz2","enabled":"enabled---WyZFv"};